import $http from '@Config/axios';

const prefix = 'clinica/analise_prescricao';

export const AnalisePrescricaoPresenter = {
	analiseSimplificada: assinatura_id => $http.get(`${prefix}/simplificada/${assinatura_id}`)
};
